export const timeTableContainer = {
    gateway: 'time-table.gateway',
};

export const tommyContainer = {
    tommy2: {
        gateway: 'tommy.2.gateway',
    },
    tommy3: {
        gateway: 'tommy.3.gateway',
        masterClient: 'tommy.3.client.master',
        operationalClient: 'tommy.3.client.operational',
        widgetClient: 'tommy.3.client.widget',
    },
};
